import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-size-14-600 ellipsis" }
const _hoisted_2 = { class: "font-size-10-400 ellipsis" }
const _hoisted_3 = { class: "subtitle mt-2" }
const _hoisted_4 = { class: "d-flex justify-center mb-4" }

import {computed} from 'vue';
import CreatedBy from "@/components/custom/CreatedBy.vue";
import Icon from "@/components/Icons/Icon.vue";
import CardComponent from "@/components/custom/CardComponent.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthGoalCard',
  props: {
  disableBtn: {
    type: Boolean,
    default: false,
  },
  healthGoal: {
    type: Object,
    default: () => {
      return {}
    },
  },
},
  setup(__props) {

const router = useRouter();

const props = __props

const isStatusArchived = computed(() => {
  return props.healthGoal?.status === 'archived';
});

const setIconAndColor = computed(() => {

  if (props.healthGoal?.status === 'archived' && props.healthGoal?.is_complete === null) {
    return {
      icon: 'health-goal-active',
      color: 'font-grey'
    }
  }

  if (props.healthGoal?.status === 'archived') {
    return {
      icon: `health-goal-${props.healthGoal.is_complete}`,
      color: 'font-grey'
    }
  }

  return {
    icon: 'health-goal-active',
    color: 'primaryColor'
  }
});

const setCreateByIcon = computed(() => {
  return props.healthGoal.creator === null ? 'client-icon' : 'practitioner-icon'
});

const setColorIfStatusArchived = computed(() => {
  return isStatusArchived.value ? 'font-grey' : 'font-black'
});

const setButtonText = computed(() => {
  return props.healthGoal.creator === null ? 'Edit' : 'View'
});

const handleAction = () => {
  if (props.healthGoal.creator === null) {
    return router.push({
      name: 'edit-health-goals',
      params: {id: props.healthGoal.id},
    });
  }

  return router.push({
    name: 'view-health-goals',
    params: {id: props.healthGoal.id},
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(CardComponent, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([{'primary-color': !isStatusArchived.value, 'font-grey': isStatusArchived.value}, "text-center font-size-10-400"])
      }, [
        _createVNode(Icon, {
          icon: setIconAndColor.value.icon,
          color: setIconAndColor.value.color
        }, null, 8, ["icon", "color"]),
        _createElementVNode("p", null, _toDisplayString(__props.healthGoal.type), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([setColorIfStatusArchived.value, "ml-2"])
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(__props.healthGoal.name), 1),
          _createElementVNode("p", _hoisted_2, _toDisplayString(__props.healthGoal.description), 1)
        ]),
        _createElementVNode("p", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([setColorIfStatusArchived.value, "text-center"])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CreatedBy, {
            color: isStatusArchived.value ? 'grey_light' : 'primaryColor',
            gap: setCreateByIcon.value === 'practitioner-icon'? '0': '4px',
            icon: setCreateByIcon.value
          }, null, 8, ["color", "gap", "icon"])
        ]),
        _createVNode(_component_v_btn, {
          class: _normalizeClass([{'white-btn': __props.healthGoal.creator !== null || isStatusArchived.value, 'primary-button': !isStatusArchived.value}, "b-round-20 outline-btn"]),
          disabled: __props.disableBtn,
          elevation: "0",
          height: "32px",
          "x-small": "",
          onClick: handleAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(setButtonText.value), 1)
          ]),
          _: 1
        }, 8, ["class", "disabled"])
      ], 2)
    ]),
    _: 3
  }))
}
}

})